import { useState, useEffect, useMemo, useContext } from 'react';
import styles from '../Applicants/css/display-applicant.module.css';
import { useQuery } from '@tanstack/react-query';
import { FilterDropDown } from '../Applicants/Applicants'; 
import { AiOutlineSearch as SearchIcon } from 'react-icons/ai';
import { IoReload as ReloadIcon } from 'react-icons/io5';
import apiCall from '../../../utils/apiCall';
import { CircularProgress, styled } from '@mui/material';
import { AxiosError } from 'axios';
import { ExNyRoute, PrRoute, ExRoute, AcRoute, MiRoute, CoRoute } from '../../../utils/allRouteId';
import { RouteResponse } from '../../../types/index';
import { FetchAllRoutes, reOrderFetchedData } from '../../../hooks/FetchData';
import { Button, DateFilter } from '../../../ui-components';
import { NotificationContext } from '../../../providers/notification';
import { apiRequest, config } from '../../../api';
import fileDownload from 'js-file-download';
import ViewDetails from "../Approvals/Modal/ViewDetails";

export interface Applicants {
  ApplicantId: string;

  Name: string;
  Phone: string;
  Email: string;
  State: string;

  Academic: string;
  Academic_Score: string;

  Hr_Experience: string;
  Hr_Experience_Score: string;

  Sector: string;

  Trainings: string;
  Total_Trainings_Score: string;

  Present_Employer: string;
  Designation: string;
  Designation_Score: string;

  Total_Score: string;

  Year_experience: string;
  Remarks: string;
  PreviousOrganization: string;
  PreviousWorkStartYear: string;
  PreviousWorkEndYear: string;
  PreviousPositionHeld: string;

  AcademicQualification: string;
  YearOfDegree: string;

  Hr_Experience_Year: string;

  Core_HR_Specialization: string;
  Core_HR_StartYear: string;
  Core_HR_EndYear: string;
  Work_Experience: string;
  Work_Experience_Score: string;
  Current_Job_score: string;
  CurrentJob: string;
  Core_Hr_Experience_Score: string;
  Core_HR_Experience: string;
}

interface DisplayApplicantsProps {
  setRouteName: React.Dispatch<React.SetStateAction<string>>;
}

const option1:any= [
    // {val:1, name:"Memembership Route",path:`${BASE_URL}`},
     {val: ExNyRoute, name:"Examination / NYSC"},
    {val:PrRoute, name:"Practitioner"},
    {val:ExRoute, name:"Executive"},
    {val: AcRoute, name:"Academic"},
    {val: MiRoute, name:"Military"},
    {val:CoRoute, name:"Corporate"}
  ]

const statusOptions = [
  { val: 1, name: "Pending Approval" },
  { val: 2, name: "Approved" }
];

const DisplayApplicant = ({ setRouteName }: DisplayApplicantsProps) => {
  const { showNotification } = useContext(NotificationContext);

  const [filters, setFilters] = useState({
    routeId: Number(ExRoute),
    searchData: '',
    date: { start: '', end: '' },
  });

  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 100;

  const [d_loading, set_d_loading] = useState(false);
  const [routeNameInt, setRouteNameInt] = useState('');

  const formatDate = (date?: string) => {
  if (!date) return 'N/A';

  const parsed = new Date(date);

  if (isNaN(parsed.getTime())) return 'N/A';

  return parsed.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
};

  const getAllApplicants = async () => {
    const params = new URLSearchParams();

    params.append('PageNumber', currentPage.toString());
    params.append('PageSize', pageSize.toString());
    params.append('RouteId', filters.routeId.toString());

    //to filter from backend
    // if (filters.searchData.trim()) {
    //   params.append('searchQuery', filters.searchData.trim());
    // }

    if (filters.date.start) {
      params.append('startDate', formatDate(filters.date.start));
    }

    if (filters.date.end) {
      params.append('endDate', formatDate(filters.date.end));
    }

    const response = await apiCall().get(
      `/Applicant/NewGetAllApplicantDetailByRouteId?${params.toString()}`
    );

    return response.data;
  };

  const getAllApplicantsQuery = useQuery(
    [
      'get-All-Applicant',
      filters.routeId,
      filters.searchData,
      filters.date.start,
      filters.date.end,
      currentPage,
    ],
    getAllApplicants,
    {
      retry: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
    }
  );

  const apiData = getAllApplicantsQuery.data;
const allApplicants = apiData?.Data ?? [];

const filteredApplicants = allApplicants.filter((applicant: Applicants) => {
  const search = filters.searchData.toLowerCase().trim();

  if (!search) return true;

  return (
    applicant.Name?.toLowerCase().includes(search) ||
    applicant.Email?.toLowerCase().includes(search)
  );
});  
const totalCount = apiData?.TotalSize ?? 0;
// const totalCount = apiData?.TotalSize ?? 0;
// const totalCount = filteredApplicants.length;

  const pageCount = Math.ceil(totalCount / pageSize);
  const [selectedApplicant, setSelectedApplicant] = useState<Applicants | null>(null);

  const startRecord =
    totalCount === 0 ? 0 : (currentPage - 1) * pageSize + 1;

  const endRecord = Math.min(currentPage * pageSize, totalCount);

  /* ================= ROUTES ================= */
  const { isLoading, data } = FetchAllRoutes();
  const reOrderedAllRoutes = data
    ? reOrderFetchedData((data as RouteResponse)?.Data)
    : [];

  const allRoutes = isLoading
    ? []
    : reOrderedAllRoutes.map(item => ({
        name: item.RouteName,
        val: item.RouteId,
      }));

  const switchRouteId = (route: { val: number; name: string }) => {
    setFilters(prev => ({ ...prev, routeId: route.val }));
    setRouteName(route.name);
    setRouteNameInt(route.name);
    setCurrentPage(1);
  };

  const handleDownload = () => {
    set_d_loading(true);

    const params = new URLSearchParams();
    params.append('routeId', filters.routeId.toString());

    if (filters.date.start) {
      params.append('startDate', formatDate(filters.date.start));
    }
    if (filters.date.end) {
      params.append('endDate', formatDate(filters.date.end));
    }

    apiRequest(
      `api/Applicant/NewDownloadAllApplicantDetailByRouteId?${params.toString()}`,
      'GET',
      {},
      config,
      true
    )
      .then((data: any) => {
        if (!data?.Message) {
          fileDownload(data, `applicants-${Date.now()}.xlsx`);
          showNotification({
            message: 'File downloading...',
            type: 'success',
          });
        } else {
          showNotification({
            message: data.Message,
            type: 'info',
          });
        }
      })
      .catch(() => {
        showNotification({
          message: 'Sorry, file cannot be downloaded',
          type: 'error',
        });
      })
      .finally(() => set_d_loading(false));
  };

 return (
  <div className={styles.container}>
    <div className={styles.filterDiv}>
      <label className={styles.searchForm}>
        <span className={styles.sI}>
          <SearchIcon />
        </span>
        <input
          type="text"
          placeholder="Search applicants..."
          value={filters.searchData}
          onChange={e => {
            setFilters(prev => ({ ...prev, searchData: e.target.value }));
            setCurrentPage(1);
          }}
        />
      </label>

      <FilterDropDown
        onChange={switchRouteId}
        text={routeNameInt || 'Membership Route'}
        bg="#0A3922"
        color="#fff"
        options={allRoutes}
      />

      <DateFilter
        onChange={(date: any) => {
          setFilters(prev => ({ ...prev, date }));
          setCurrentPage(1);
        }}
      />

      <Button
        onClick={handleDownload}
        children={d_loading ? 'Downloading...' : 'Download'}
        border="#E2E4E9"
        bg="#0A3922"
        color="#fff"
      />
    </div>

    {/* ================= RECORD SUMMARY ================= */}
    {!getAllApplicantsQuery.isLoading && (
      <div className={styles.recordBar}>
        Showing <strong>{startRecord}</strong>–<strong>{endRecord}</strong> of{" "}
        <strong>{totalCount}</strong> applicants
      </div>
    )}

    {getAllApplicantsQuery.isLoading ? (
      <div className={styles.loaderWrapper}>
        <CircularProgress />
      </div>
    ) : filteredApplicants.length ? (
      <>
        <div className={styles.tableWrapper}>
          <table className={styles.modernTable}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>State</th>
                <th>Academic</th>
                <th>Academic Score</th>
                <th>Work_Experience</th>
                <th>Work_Experience Score</th>
                <th>Trainings</th>
                <th>Total_Trainings_Score</th>
                <th>CurrentJob</th>
                <th>CurrentJob Score</th>
                <th>Sector</th>
                <th>Core_HR_Experience</th>
                <th>Core_Hr_Experience_Score</th>
                <th>Total_Score</th>
                {/* <th>Previous Position Held</th>
                <th>Previous Work Start</th>
                <th>Previous Work End</th>
                <th>Academic Qualification</th>
                <th>Year of Degree</th>
                <th>HR Experience Year</th>
                <th>Core HR Specialization</th>
                <th>Core HR Start Year</th>
                <th>Core HR End Year</th>
                <th>Remarks</th>
                <th>Action</th> */}
              </tr>
            </thead>

            <tbody>
              {filteredApplicants.map((applicant: Applicants) => {
                const total = Number(applicant.Total_Score) || 0;

                return (
                 <tr key={applicant.ApplicantId}>
                <td>{applicant.Name || 'N/A'}</td>
                <td>{applicant.Email || 'N/A'}</td>
                <td>{applicant.Phone || 'N/A'}</td>
                <td>{applicant.State || 'N/A'}</td>

                <td className={styles.truncate} title={applicant.Academic}>
                  {applicant.Academic || 'N/A'}
                </td>

                <td className={styles.numberCell}>
                  {Number(applicant.Academic_Score) || 0}
                </td>

                <td className={styles.truncate} title={applicant.Work_Experience}>
                  {applicant.Work_Experience || 'N/A'}
                </td>

                <td className={styles.numberCell}>
                  {Number(applicant.Work_Experience_Score) || 0}
                </td>

                <td className={styles.truncate} title={applicant.Trainings}>
                  {applicant.Trainings || 'N/A'}
                </td>

                <td className={styles.numberCell}>
                  {Number(applicant.Total_Trainings_Score) || 0}
                </td>

                <td className={styles.truncate} title={applicant.CurrentJob}>
                  {applicant.CurrentJob || 'N/A'}
                </td>

                <td className={styles.numberCell}>
                  {Number(applicant.Current_Job_score) || 0}
                </td>

                <td>{applicant.Sector || 'N/A'}</td>

                <td>{applicant.Core_HR_Experience || 'N/A'}</td>

                <td className={styles.numberCell}>
                  {Number(applicant.Core_Hr_Experience_Score) || 0}
                </td>

                <td>
                  <span className={styles.scoreBadge}>{total}</span>
                </td>

                <td>
                  <button onClick={() => setSelectedApplicant(applicant)}>
                    View
                  </button>
                </td>
              </tr>
                );
              })}
            </tbody>
          </table>
      {selectedApplicant && (
      <ViewDetails
        data={selectedApplicant}
        onChange={() => setSelectedApplicant(null)}
        showActions={false} // This hides the button specifically for this view
      />
    )}
        </div>

        <div className={styles.pagination}>
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(p => p - 1)}
            className={styles.pageButton}
          >
            Prev
          </button>

          <span className={styles.pageInfo}>
            Page {currentPage} of {pageCount}
          </span>

          <button
            disabled={currentPage === pageCount}
            onClick={() => setCurrentPage(p => p + 1)}
            className={styles.pageButton}
          >
            Next
          </button>
        </div>
      </>
    ) : (
      <NoResult>No Results</NoResult>
    )}
  </div>
);
};

export default DisplayApplicant;

const StyledError = styled('p')`
  color: red;
  font-size: 1.4rem;
  display: flex;
`;

const NoResult = styled('div')`
  margin-block-start: 0px;
`;
